import React from 'react';
import Button from 'components/V1/Button/Button';
import Icon from 'components/V1/Icon/Icon';
import { ReactComponent as MenuIcon } from 'icons/menu.svg';

interface TopBarProps {
  onClick: () => void;
}

function MobileNavButton({ onClick }: TopBarProps) {
  return (
    <Button
      css={{
        color: '$secondaryGrey',
        '&:focus': { color: '$secondary' },
        '@md': { display: 'none' },
      }}
      onClick={onClick}
      aria-label="Menu"
    >
      <Icon as={MenuIcon} />
    </Button>
  );
}

export default MobileNavButton;
